import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="show-disabled-balances"
export default class extends Controller {
  connect() {
    console.log("showDisabledBalances controller connected");
  }

  show(event) {
    event.preventDefault();
    document.querySelectorAll("tr.table-secondary").forEach((row) => {
      row.style.display = "";
    });
  }
}
